export default "__VITE_ASSET__D8UXCtO4__"